class Remote extends HTMLElement {
  constructor(
    options = {
      target: null,
      family: null,
      triggerEvent: 'click',
      action: 'toggle',
      /* isOpen: false,*/ openEffect: false,
      effect: false,
      closeFamily: false,
      clickOutsideClose: false,
      default: false,
      closeTargets: [],
      openTargets: [],
    }
  ) {
    super();
    if (this.initialized) return;

    this.selector = options.target;
    this.family = options.family;
    this.closeFamily = options.closeFamily;
    this.triggerEvent = options.triggerEvent;
    this.action = options.action;
    this.openEffect = options.openEffect;
    this.effect = options.effect;
    this.firstLoad = true;
    this.querySelectors = [];
    this.families = [];
    this.clickOutsideClose = options.clickOutsideClose;
    this.default = options.default;
    this.firstLoad = true;
    this.closeTargets = options.closeTargets;
    this.openTargets = options.openTargets;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {}

  init() {
    this.setTarget();
    this.family = this.getAttribute('family') ?? this.family;
    this.closeFamily = this.getAttribute('close-family') ?? this.closeFamily;
    this.openEffect = this.getAttribute('open-effect') ?? this.openEffect;
    this.effect = this.getAttribute('effect') ?? this.getAttribute('effect') == 'true' ? true : this.effect;
    this.triggerEvent = this.getAttribute('trigger-event') ?? this.triggerEvent;
    this.action = this.getAttribute('action') ?? this.action;
    this.clickOutsideClose =
      this.getAttribute('click-outside-close') ??
      (this.getAttribute('click-outside-close') === 'true' || this.getAttribute('click-outside-close') === '')
        ? true
        : this.clickOutsideClose;
    this.default = this.target.hasAttribute('data-default');
    this.closeTargets = this.getAttribute('close-targets')
      ? this.getAttribute('close-targets').split(',')
      : this.closeTargets;
    this.openTargets = this.getAttribute('open-targets')
      ? this.getAttribute('open-targets').split(',')
      : this.openTargets;

    this.allRemotes = document.querySelectorAll('mca-remote');
    if (this.target == null) {
      console.error(this);
      console.error(this.selector + ' not found');
    }
    this.target.classList.add('remote-connected');

    if (this.target.hasAttribute('open')) {
      this.open();
    }

    this.setAccessibilityAttributes();

    if (this.openEffect) {
      this.setInitialDimensionsToTargets(this.target);
    }

    if (this.clickOutsideClose) {
      if (this.target.tagName == 'MCA-REMOTE') {
        return;
      } else {
        document.addEventListener('click', (event) => {
          if (event.target.closest('mca-remote')) return;
          if (!this.target.contains(event.target) && this.isTargetOpen()) {
            // if (!this.contains(event.target) && !event.target.closest(this.selector) && this.isTargetOpen(this.target) /* && this.isOpen */) {
            // 	this.close();
            // }
            this.close();
          }
        });
      }
    }

    this.listenEvent();
    this.watchOpenAttributeOnTarget(this.target);
    this.firstLoad = false;

    this.dispatchEvent(
      new CustomEvent('remote:initialized', {
        detail: {
          remote: this,
          target: this.target,
          state: this.target.hasAttribute('open') ? 'open' : 'close',
        },
      })
    );
    this.initialized = true;
  }

  setTarget() {
    this.selector = this.getAttribute('target') ?? this.selector;
    this.target = document.querySelector(this.selector) ?? console.error(this.selector + ' not found');
  }

  runAction() {
    switch (this.action) {
      case 'toggle':
        this.toggle();
        break;
      case 'open':
        this.open();
        if (this.openTargets.length > 0) this.simpleOpen();
        break;
      case 'close':
        this.close();
        if (this.closeTargets.length > 0) this.simpleClose();
        break;
      default:
        this.toggle();
    }
  }

  listenEvent() {
    this.addEventListener(this.triggerEvent, this.runAction);
    this.addEventListener('keydown', this.listenKeydown);
  }

  listenKeydown(e) {
    switch (e.code) {
      case 13:
        this.runAction();
        break;
      case 32:
        this.runAction();
        break;
      case 'Space':
        this.runAction();
        break;
      case 'Enter':
        this.runAction();
        break;
      default:
        break;
    }
  }

  setAccessibilityAttributes() {
    this.setAttribute('role', 'button');
    this.setAttribute('aria-pressed', false);
    this.setAttribute('tabindex', 0);
    this.style.cursor = 'pointer';
  }

  toggle() {
    if (this.target.tagName == 'MCA-REMOTE') {
      const remote = this.target;
      if (remote.isTargetOpen(remote.target)) {
        remote.close();
      } else {
        remote.open();
      }
    } else {
      if (this.isTargetOpen(this.target)) {
        /* FIX THIS */
        this.close();
      } else {
        this.open();
      }
      if (this.closeTargets.length > 0) this.simpleClose();
      if (this.openTargets.length > 0) this.simpleOpen();
      if (this.family && !this.default) {
        this.closeRemoteFamily();
      }
    }
  }

  activeRemote(remote = this) {
    remote.setAttribute('aria-expanded', true);
    remote.classList.add('active');
    remote.setAttribute('aria-pressed', true);
  }

  desactiveRemote(remote = this) {
    remote.setAttribute('aria-expanded', false);
    remote.classList.remove('active');
    remote.setAttribute('aria-pressed', false);
  }

  open(remote = this, target = this.target, checkFamilies = true) {
    console.log(this.target);
    if (!this.firstLoad && this.isTargetOpen(target)) {
      return;
    }
    if (checkFamilies && this.family && !this.default) {
      this.closeRemoteFamily();
    }

    // if (checkFamilies) {
    // 	if (this.family) { this.closeRemoteFamily(); }
    // }

    // if (this.closeFamily) {
    // 	const families = this.createFamilyArray(this.closeFamily);
    // 	families.forEach((family) => {
    // 		this.closeRemoteFamily(family);
    // 	});
    // }

    this.activeRemote(remote);

    target.classList.add('active');

    target.setAttribute('open', '');
    if (this.openEffect == 'height') target.style.height = target.getAttribute('height') + 'px';
    if (this.openEffect == 'width') target.style.width = target.getAttribute('width') + 'px';

    this.dispatchEvent(
      new CustomEvent('remote:changeState', {
        detail: { remote: remote, target: target, state: target.hasAttribute('open') ? 'open' : 'close' },
      })
    );
    this.dispatchEvent(new CustomEvent('remote:open', { detail: { remote: remote, target: target } }));
  }

  close(remote = this, target = this.target) {
    if (!this.isTargetOpen(target)) {
      // console.log('already close', this);
      return;
    }

    // this.closeRemoteFamily();
    // if (this.family && !this.default) { this.closeRemoteFamily(); }
    this.desactiveRemote(remote);

    target.classList.remove('active');
    target.removeAttribute('open');
    if (this.openEffect && this.openEffect == 'height') target.style.height = 0;
    if (this.openEffect && this.openEffect == 'width') target.style.width = 0;

    this.dispatchEvent(
      new CustomEvent('remote:changeState', {
        detail: { remote: remote, target: target, state: target.hasAttribute('open') ? 'open' : 'close' },
      })
    );
    this.dispatchEvent(new CustomEvent('remote:close', { detail: { remote: remote, target: target } }));
  }

  simpleOpen(targets = this.openTargets) {
    targets.forEach((target) => {
      target = document.querySelector(target);
      target.setAttribute('open', '');
      if (this.openEffect == 'height') target.style.height = target.getAttribute('height') + 'px';
      if (this.openEffect == 'width') target.style.width = target.getAttribute('width') + 'px';
    });
  }

  simpleClose(targets = this.closeTargets) {
    targets.forEach((target) => {
      console.log('yeah');
      target = document.querySelector(target);
      target.removeAttribute('open');
      if (this.openEffect && this.openEffect == 'height') target.style.height = 0;
      if (this.openEffect && this.openEffect == 'width') target.style.width = 0;
    });
  }

  setInitialDimensionsToTargets(target = this.target) {
    if (!target.hasAttribute('height')) {
      target.setAttribute('height', target.scrollHeight);
    }
    if (!target.hasAttribute('width')) {
      target.setAttribute('width', target.offsetWidth);
    }
  }

  isTargetOpen(target = this.target) {
    return target.hasAttribute('open');
  }

  createFamilyArray(familyAttr) {
    let familyMembers = [];
    familyMembers = familyAttr.split(',');
    familyMembers = familyMembers.map((family) => {
      return family.trim();
    });
    return familyMembers;
  }

  closeRemoteFamily(targetFamily = this.family) {
    if (this.firstLoad) return;
    let allRemoteIsClose = false;
    let defaultRemote = null;
    const remotesFamily = document.querySelectorAll('mca-remote[family]');
    remotesFamily.forEach((remote) => {
      if (!allRemoteIsClose) allRemoteIsClose = remote.isTargetOpen();
      if (!defaultRemote && remote.default) defaultRemote = remote;

      const family = remote.getAttribute('family');
      if (targetFamily === family && remote != this) {
        remote.close();
      }
    });
    if (!allRemoteIsClose && defaultRemote) {
      defaultRemote.open(defaultRemote, defaultRemote.target, false);
    }
  }

  onAttributeChange(attributeName, callback) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
          callback(this.getAttribute(attributeName));
        }
      }
    });
    observer.observe(this, { attributes: true });
  }

  watchOpenAttributeOnTarget(target = this.target) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (target.hasAttribute('open')) {
            this.activeRemote();
          } else {
            this.desactiveRemote();
          }
        }
      }
    });
    observer.observe(target, { attributes: true });
  }
}

if (!customElements.get('mca-remote')) {
  customElements.define('mca-remote', Remote);
}
